define("Ames.RentFromAnywhere.RequestRentalExtension.View", [
  "rental_request_extension.tpl",
  "Ames.RentFromAnywhere.RentFromAnywhere.SS2Model",
  "Backbone",
  "Profile.Model",
  "Utils",
  "jQuery",
], function (
  rentalRequestExtensionTpl,
  RentFromAnywhereSS2Model,
  Backbone,
  ProfileModel,
  Utils,
  jQuery
) {
  "use strict";

  return Backbone.View.extend({
    template: rentalRequestExtensionTpl,

    initialize: function (options) {
      this.orderId = options.orderId;
      this.itemId = options.itemId;
      this.index = options.index;
      this.model = new RentFromAnywhereSS2Model();
    },

    events: {
      "click [data-action='submit-rental-extension-request']":
        "submitExtensionRequest",
    },

    submitExtensionRequest: function (e) {
      e.preventDefault();
      e.stopPropagation();

      var self = this;
      var $btn = this.$("[data-action='submit-rental-extension-request']");

      $btn.prop("disabled", true).text("Submitting...");

      var itemId = this.itemId;
      var salesOrderId = this.orderId;
      var index = this.index;

      this.model
        .fetch({
          data: {
            submitExtensionRequest: true,
            orderId: salesOrderId,
            itemId: itemId,
            replacementItemId: itemId,
            index: index,
          },
        })
        .done(function (response) {
          if (response && response.success) {
            alert(
              "Your replacement request has been submitted. Our team will review it and email you the tracking number of the replacement unit along with a prepaid return label."
            );
            Backbone.history.navigate("rental-orders", { trigger: true });
          } else {
            alert(
              "There was an error submitting your request. Please try again later."
            );
            $btn.prop("disabled", false).text("Submit Request");
          }
        })
        .fail(function () {
          alert(
            "There was an error submitting your request. Please try again later."
          );
          $btn.prop("disabled", false).text("Submit Request");
        });
    },

    getContext: function () {
      return {
        orderId: this.orderId,
        itemId: this.itemId,
      };
    },
  });
});
